<!--
    描述：左边项目结构信息
    时间：2020.5.27
    created by 张卫华
-->
<template>
    <div class="baseForm-layout h100 main-page">
        <div class="baseForm-header" v-if="showLeft">
            项目结构:
            <el-button title="折叠" class="ml10" type="text" @click="changeShow" icon="el-icon-d-arrow-left"></el-button>
            <div class="btnGroups">
                <el-select v-model="curLevel"
                           class="ml10 select-width"
                           placeholder="请选择"
                           size="small"
                           @change="onChangeLevel">
                    <el-option :value="0"
                               label="展开到一级"></el-option>
                    <el-option :value="1"
                               label="展开到二级"></el-option>
                    <el-option :value="2"
                               label="展开到三级"></el-option>
                    <!-- <el-option :value="3"
                               label="展开到四级"></el-option> -->
                </el-select>
            </div>
        </div>
        <div class="baseForm-header" v-else>
            <el-button title="展开" size="" type="text" @click="changeShow" icon="el-icon-d-arrow-right"></el-button>
        </div>

        <div class="baseForm-content h100" v-show="showLeft">
            <div class="w-table-content h100" ref="tableContent">
                <el-table :data="tableObj.tableData"
                          row-key="id"
                          v-loading="tableObj.loading"
                          ref="structureTree"
                          :height="tableObj.tableH"
                          border
                          :expand-row-keys="expandKeys"
                          highlight-current-row
                          :row-class-name="rowClassName"
                          @row-click="rowClick"
                          :tree-props="{children: 'children'}">
                    <el-table-column prop="sname" label="项目名称" header-align="center" align="left" show-overflow-tooltip
                                     min-width="140">
                        <template slot-scope="scope">
                            <el-tooltip class="item"
                                        effect="dark"
                                        :content="scope.row.sname"
                                        placement="right">
                            <span class="text-overflow"
                                  :class="scope.row.levelType === 0 ? 'cell-text' : 'cell-tooltip'">{{ scope.row.levelType === 0 ? scope.row.sname : '' }}</span>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column prop="singleName"
                                     label="单项工程名称"
                                     show-overflow-tooltip
                                     width="120">
                        <template slot-scope="scope">{{ scope.row.levelType === 1 ? scope.row.sname : '' }}</template>
                    </el-table-column>
                    <el-table-column prop="unitName"
                                     width="120"
                                     label="单位工程名称"
                                     show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.levelType === 2 ? scope.row.sname : '' }}</template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import {getStructureData} from '@/api/modules/dataProject'

    export default {
        name: '',
        props: {
            projectId: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                showLeft: true,
                curLevel: 2,
                staticData: [],
                expandKeys: [],
                tableObj: {
                    loading: false,
                    tableH: 200,
                    tableData: []
                }
            }
        },

        computed: {
            ...mapState('app', {clientSize: state => state.clientSize}),
        },
        mounted() {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.tableObj.tableH = this.$refs.tableContent.offsetHeight
                }, 100)
            })
        },
        watch: {
            clientSize(val) {
                setTimeout(() => {
                    this.tableObj.tableH = this.$refs.tableContent.offsetHeight
                }, 100)
            },
            // 监听项目ID 的变化
            projectId(val) {
                // console.log(val)
                this.getTableList()
            }
        },
        created() {
            this.getTableList()
        },
        methods: {
            getTableList() {
                this.tableObj.tableData = []
                //getStructureData({projectId: '1263759582716727297',type : 0}).then(res => {
                getStructureData({id: this.projectId}).then(res => {
                    if (res.code === 0) {
                        // 改造数据
                        res.data.pid = '0'
                        if (res.data.children && res.data.children.length > 0) {
                            res.data.children.forEach(x => {
                                x.pid = res.data.id
                            })
                        }
                        this.tableObj.tableData.push(res.data)
                        this.staticData = this.tableObj.tableData
                        // 设置高亮
                        if (this.$refs.structureTree) {
                            this.$refs.structureTree.setCurrentRow(res.data)
                            setTimeout(() => {
                                this.rowClick(res.data)
                                this.onChangeLevel(2)
                            }, 300)
                        }
                    }
                })
                    .catch(err => {

                    })
            },
            rowClick(row) {
                this.$emit('row-click', this.tableObj.tableData, row)
            },
            // 行样式
            rowClassName({row, rowIndex}) {
                if (row.levelType === 0) {
                    return 'project-row'
                } else if (row.levelType === 1) {
                    return 'single-row'
                } else if (row.levelType === 2) {
                    return 'unit-row'
                }
                return ''
            },
            // 控制左侧展开收起
            changeShow() {
                this.showLeft = !this.showLeft
                this.$emit('changeShow', this.showLeft)
            },

            // 点击切换展开层级
            onChangeLevel(val) {
                this.tableObj.loading = true;
                // 先清空
                this.tableObj.tableData = [];
                this.expandKeys = [];
                // 设置 level
                let _data = JSON.parse(JSON.stringify(this.staticData));
                this.expandLevel(_data, val, this.expandKeys);

                // 展示表格
                setTimeout(() => {
                    this.tableObj.loading = false;
                    this.tableObj.tableData = this.staticData;
                    this.$refs.structureTree.doLayout()
                }, 500)
            },

            // 默认key 值展开
            expandLevel(arr, level, backArr) {
                if (arr.length > 0) {
                    arr.forEach(x => {
                        if (x.children && x.levelType < level) {
                            backArr.push(x.id)
                            this.expandLevel(x.children, level, backArr)
                        }
                    })
                }
            },

            resizeTableH() {
                this.tableObj.tableH = this.$refs.tableContent.offsetHeight
            },
        },
        // 进入缓存页面触发
        activated() {
            this.$nextTick(() => {
                this.tableObj.tableH = this.$refs.tableContent.offsetHeight
            })
        },
    }
</script>
<style lang="less" scoped>
    .main-page {
        .baseForm-content {
            padding: 10px 0px;
            overflow-y: auto;
        }

        .select-width {
            width: 150px;
        }
    }
</style>
